import React from "react"

class SkipToLink extends React.Component{
    render(){
        return(
            <a className="skip-to-content-link" href="#mainContent">
                Skip to content
            </a>)
    }
}

export default SkipToLink